// Module-scoped per-survey draft so un-applied edits survive closing the modal without re-rendering
// the survey page on every keystroke.
const draftsBySurveyId = new Map();

/**
 * @param {?(number|string)} surveyId
 * @return {?Object} the stored draft map (`${entityKey}:${language}` -> entry), or null
 */
export const getTranslationDraft = (surveyId) =>
  surveyId == null ? null : draftsBySurveyId.get(surveyId) || null;

/**
 * @param {?(number|string)} surveyId
 * @param {Object} draft the working translations map to persist
 */
export const setTranslationDraft = (surveyId, draft) => {
  if (surveyId == null) return;
  draftsBySurveyId.set(surveyId, draft);
};

/**
 * Drop a survey's draft — called on Apply Changes, once its strings have moved to the survey object.
 * @param {?(number|string)} surveyId
 */
export const clearTranslationDraft = (surveyId) => {
  if (surveyId == null) return;
  draftsBySurveyId.delete(surveyId);
};
